import { styled } from 'solid-styled-components';
import theme from '../style/theme';

export const StyledAppRoot = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    img {
        max-width: 100%;
    }
`;

export const StyledAppInner = styled.main`
    flex: 1;
    z-index: 1;
    @media screen {
        padding-bottom: 8rem;
    }
`;

export const StyledPdfFactoryRoot = styled.div`
    overflow: hidden;
    height: 0;
    @media print {
        height: auto;
    }
`;

export const StyledChatbotTeaserButtonFlexRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    ${theme.mediaQueries.mobileMax} {
        flex-direction: column;
        gap: 0;
    }
`;

export const StyledFakeChatbotBubble = styled.button`
    position: fixed;
    bottom: 2.4rem;
    right: 2.6rem;
    width: 5rem;
    height: 5rem;
    background-color: #f3756b;
    padding: 1.15rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 5px 0 rgba(45,45,45,0.5);
    cursor: pointer;
    z-index: 1000;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #F0A39D;
    }
`;

